// CANONICAL COPY (GH #7115). src/constants/obligations/obl-privileged-utilities.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-privileged-utilities',
  title: 'Review privileged utility programs and unnecessary services',
  description:
    'Confirm that the use of utility programs capable of overriding system and application controls is restricted and tightly controlled. Unnecessary services, applications, network ports, protocols and privileged utilities shall be uninstalled or disabled on enterprise assets to minimise attack surface. Review exceptions and compensating controls.',
  category: 'technical',
  scfIds: ['SCF-OPS-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Privileged utilities / service hardening standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
